import React, { FC } from 'react';
import { TGateValues } from '../types';
import { TDistanceUnit, TVerticalDistanceUnit } from '@ems/client-design-system';
import {
  LegendRoot,
  LegendSection,
  LegendHeading,
  SameDirectionMarker,
  OppositeDirectionMarker,
  LegendItemsContainer,
  LegendItem,
} from './DeviationChartLegend.styles';

export { SameDirectionMarker, OppositeDirectionMarker, LegendItemsContainer, LegendItem };

interface DeviationChartLegendProps {
  translations: {
    gateDirection: string;
    gateDirectionSame: string;
    gateDirectionOpposite: string;
    gateWidth: string;
    floorHeight: string;
    ceilingHeight: string;
    gateValues: string;
  };
  gateValues: TGateValues | null;
  units: {
    vertical: TVerticalDistanceUnit;
    horizontal: TDistanceUnit;
  };
}

/**
 * Displays a legend for the gate deviation chart markers
 */
export const DeviationChartLegend: FC<DeviationChartLegendProps> = ({
  translations,
  gateValues,
  units,
}) => (
  <LegendRoot>
    <LegendSection>
      <LegendHeading>{translations.gateDirection}</LegendHeading>
      <LegendItemsContainer>
        <LegendItem>
          <SameDirectionMarker />
          {translations.gateDirectionSame}
        </LegendItem>
        <LegendItem>
          <OppositeDirectionMarker />
          {translations.gateDirectionOpposite}
        </LegendItem>
      </LegendItemsContainer>
    </LegendSection>

    {gateValues && (
      <LegendSection>
        <LegendHeading>{translations.gateValues}</LegendHeading>
        <LegendItemsContainer>
          <LegendItem>
            {translations.ceilingHeight}: {gateValues.ceilingAltitude.toLocaleString()} {units.vertical}
          </LegendItem>
          <LegendItem>
            {translations.floorHeight}: {gateValues.floorAltitude.toLocaleString()} {units.vertical}
          </LegendItem>
          <LegendItem>
            {translations.gateWidth}: {gateValues.gateWidth.toLocaleString()} {units.horizontal}
          </LegendItem>
        </LegendItemsContainer>
      </LegendSection>
    )}
  </LegendRoot>
);
